import {
  ICandidateFilter,
  ICandidateSubmissionSearchFilterVM,
  IJobCandidateInteraction,
} from 'wisestep-api';

import JobsCrmPipelineAdvanceFiltersFormProps from '../../../components/filters/models/JobsCrmPipelineAdvanceFiltersFormProps';

export const defaultSimilarJobsSubmissionQuery = (): ICandidateSubmissionSearchFilterVM => ({
  workspaceId: '',
  query: '',
  page: 0,
  size: 15,
  filters: [],
  sort: [],
  jobs: [],
});

export const defaultSimilarJobsMappingsQuery = (): IJobCandidateInteraction => ({
  timeTakenInMillis: 0,
  page: 0,
  size: 20,
  sort: ['_score,desc'],
  minSalary: 0,
  maxSalary: 0,
  radiusInMiles: 100,
  searchScope: 'EVERYTHING',
  candidateSearchTypeList: ['mapped'],
  jobSearchFields: ['currentJobTitle', 'mappedJobTitle', 'previousJobTitles'],
  datesUnionBy: 'UPDATED_BETWEEN',
  searchAcross: ['ACROSS_WORKSPACE'],
  candidateSearchType: 'OnlyMappings',
  minMatchScore: 60,
});

export const getDefaultSimilarJobsMappingsQueryPayload = (
  jobIds: string[]
): IJobCandidateInteraction => ({ ...defaultSimilarJobsMappingsQuery(), jobIds: jobIds.join(',') });

export const getDefaultSimilarJobsSubmissionsQueryPayload = (
  jobFilter: ICandidateFilter,
  size: number
): ICandidateSubmissionSearchFilterVM => ({
  ...defaultSimilarJobsSubmissionQuery(),
  filters: [jobFilter],
  size: size,
});

export const tabList = (mappingCount?: number, submissionCount?: number) => {
  return [
    {
      tabName: 'Submission' + `(${submissionCount ?? 0})`,
    },
    {
      tabName: 'Mapping' + `(${mappingCount ?? 0})`,
    },
  ];
};

export type SimilarJobsDrawerType = 'Sms' | 'Email' | 'None';

export interface Ipagination {
  size: number;
  pageNumber: number;
}

export const updateAdvancedQuery = (
  data: JobsCrmPipelineAdvanceFiltersFormProps,
  query: IJobCandidateInteraction
): IJobCandidateInteraction => {
  const updatedQuery = { ...query };
  ['emailAvailability', 'phoneAvailability', 'commPreferenceEmail', 'commPreferencePhone'].forEach(
    (field) => delete updatedQuery[field]
  );
  updatedQuery.page = 0;
  updatedQuery.radiusInMiles = undefined;
  updatedQuery.sources = data.source ?? [];
  updatedQuery.tags = data.tags ?? [];
  updatedQuery.workAuthorizationCategories = [];
  data.workAuthorization?.forEach((obj) => {
    updatedQuery.workAuthorizationCategories?.push(obj);
  });
  updatedQuery.minSalary = data.salaryRange?.min ?? 0;
  updatedQuery.maxSalary = data.salaryRange?.max ?? 0;
  updatedQuery.salaryCurrency = data.salaryRange?.currency ?? '';
  updatedQuery.salaryTimeSpan = data.salaryRange?.unitTime ?? null;
  updatedQuery.noticePeriodMaxDays = data.noticePeriod?.max ?? 0;
  updatedQuery.noticePeriodMinDays = data.noticePeriod?.min ?? 0;
  updatedQuery.relocationPreference = data.relocationPreferences ?? null;
  if (data.currentStageCurrentStatusPairs) {
    const stageStstusObj = JSON.parse(data.currentStageCurrentStatusPairs);
    updatedQuery.currentStageCurrentStatusPairs = stageStstusObj.stageStatusData;
    updatedQuery.candidateJobStatus =
      stageStstusObj.jobOption === 'open_jobs'
        ? 'Opened'
        : stageStstusObj.jobOption === 'closed_jobs'
        ? 'Closed'
        : 'Any';
  } else {
    updatedQuery.currentStageCurrentStatusPairs = [];
    updatedQuery.candidateJobStatus = 'Any';
  }

  data.commPreferences?.forEach((value) => {
    if (value === 'Email') updatedQuery.commPreferenceEmail = true;
    else if (value === 'Phone') updatedQuery.commPreferencePhone = true;
  });
  data.contactAvailability?.forEach((value) => {
    if (value === 'Email') updatedQuery.emailAvailability = true;
    else if (value === 'Phone') updatedQuery.phoneAvailability = true;
    else if (value === 'Both') {
      updatedQuery.phoneAvailability = true;
      updatedQuery.emailAvailability = true;
    }
  });
  updatedQuery.createdByRecruiter = data.createdBy ?? [];
  return updatedQuery;
};
